import styled, { css } from 'styled-components';

import { lighten } from 'utils/colours';
import { InputNumber as AntdInputNumber } from 'antd';

export const inputStylesOverride = css`
    &.ant-input-number:focus,
    &.ant-input-number-focused {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }

    &.ant-input-number-handler:hover .ant-input-number-handler-up-inner,
    &.ant-input-number-handler:hover .ant-input-number-handler-down-inner {
        color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    &.ant-input-number:hover {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
`;

const InputNumber = styled(AntdInputNumber)`
    ${inputStylesOverride};
`;

export default InputNumber;
